import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Role} from "../../../../../models/role";
import {RoleStatus} from "../../../../../models/role-status";
import { ClassificationType } from "../../../../../models/classification-type";
import {RoleStatusMessage} from "../../../../../models/status-message";
import {MessageControllerService} from "../../../../../services/message-controller/message-controller.service";
import {RoleStatusControllerService} from "../../../../../services/role-controller/role-status-controller.service";
import {RoleStatusService} from "../../../../../services/role-controller/role-status.service";
import {Store} from "../../../../../services/store.service";
import {RoleDetailComponent} from "../../../roles/role-detail.component";
import {RoleControllerService} from "../../../../../services/role-controller/role-controller.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import * as _ from "lodash";

@Component({
  selector: "status-role",
  templateUrl: "./status-role.component.html",
  providers: [
    RoleStatusControllerService,
    ToastrService,
    MessageControllerService,
    RoleControllerService,
  ],
})
export class StatusRoleComponent extends TranslatedBaseError implements OnChanges, OnInit, OnDestroy {

  @Input() public role: Role;
  @Input() public status: RoleStatus;
  @Input() public rejectionReasons: ClassificationType;
  @Input() public destinations: Role[];
  @Output() public statusUpdated = new EventEmitter();
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public modalOpenedEvent = new EventEmitter();
  @Output() public updateRejectionReason = new EventEmitter();
  public serviceId: string;
  public roleId: string;
  public allRoles: any[];
  public filteredRoles: any[] = [];
  public selectedRoles: any[] = [];
  public statusMessages: RoleStatusMessage[] = [];
  public statusAlerts: RoleStatusMessage[] = [];
  public hideContent: boolean = false;
  public subscription: any;
  // TOBE-17769: options for the FileDeclineStatus resubmit-mode toggle.
  // Values must match the backend ResubmitMode enum. Default is the first entry.
  public resubmitModeOptions = [
    {label: "roles.status.fileDecline.resubmitMode.deterministicFlow", value: "DETERMINISTIC_FLOW"},
    {label: "roles.status.fileDecline.resubmitMode.toRequestingRoleOnly", value: "TO_REQUESTING_ROLE_ONLY"},
  ];
  // for role ancestors
  public ancestors: any[] = [];
  public activeMenuRoles: Role[] = [];
  public baseRoles: Role[] = [];

  constructor(private roleStatusControllerService: RoleStatusControllerService,
              private roleStatusService: RoleStatusService,
              private roleDetail: RoleDetailComponent,
              public store: Store,
              toastr: ToastrService, private route: ActivatedRoute,
              public translateService: TranslateService,
              private roleController: RoleControllerService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.roleId = params.roleId;
    });
    this.subscription = this.roleStatusService.update.subscribe((data) => {
      // console.log("--- Staus role", data, this.status.roleStatusType);
      if (data.update && this.status.roleStatusType === data.statusType && this.status.roleId === this.roleId) {
        if (data.roleStatusMessage && data.roleStatusMessage.message && data.roleStatusMessage.message.messageType === "ALERT") {
          this.statusAlertSubmit(data.roleStatusMessage, data.statusType);
        } else {
          this.statusMessageSubmit(data.roleStatusMessage, data.statusType);
        }
      }
    });
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.status && changes.status.currentValue) {
      this.status = changes.status.currentValue;
      this.initStatusMessages();
    }
    if (changes.destinations && changes.destinations.currentValue) {
      this.baseRoles = changes.destinations.currentValue;
      this.generateRolesList(changes.destinations.currentValue);
    }
  }

  public generateRolesList(roles: any[]): void {
    roles = roles.filter((role) => role.shortName !== "AP" && !role.isFrontendBot);
    this.activeMenuRoles = roles;
    roles.forEach((role) => {
      if (role.statuses && role.statuses.length > 0) {
        role.statuses.forEach((status) => {
          if (status.name === "FILE VALIDATED" && status.destinations.length) {
            const nextRoles = [];
            status.destinations.forEach((dest) => {
              roles.forEach((r) => {
                if (r.id === dest.destinationId) {
                  nextRoles.push(r);
                }
              });
            });
            role.nextRoles = nextRoles;
          }
        });
      }
    });

    this.generateAncestorsList(this.role.id);
    this.pushToRolesDropDownValues(this.baseRoles);

  }

  public generateAncestorsList(id): void {
    this.haveAncestors(id).forEach((anc) => {
      this.ancestors.push(anc.id);
      this.generateAncestorsList(anc.id);
    });
  }

  public haveAncestors(id): Role[] {
    const roles: Role[] = [];
    this.activeMenuRoles.forEach((r) => {
      if (r.nextRoles && r.nextRoles.length) {
        r.nextRoles.forEach((nr) => {
          if (nr.id === id) {
            roles.push(r);
          }
        });
      }
    });
    return roles;
  }

  public isAncestor(id): boolean {
    return this.ancestors.filter((r) => r === id).length > 0;
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public initStatusMessages() {
    this.statusAlerts = [];
    this.statusMessages = [];
    if (this.status.statusMessages) {
      this.status.statusMessages.forEach((msg) => {
        if (msg.message.messageType === "MESSAGE") {
          this.statusMessages.push(_.cloneDeep(msg));
        } else {
          this.statusAlerts.push(_.cloneDeep(msg));
        }
      });
    }
  }

  public pushToRolesDropDownValues(destinations: Role[]) {
    this.destinations = destinations;
    this.allRoles = (this.allRoles) ? this.allRoles : [];
    this.selectedRoles = [];
    const additionalRoles = this.destinations.filter((item) => this.role.id !== item.id)
      .map((item) => {
          return {id: item.id, text: item.name};
    });
    this.allRoles = this.allRoles.concat(additionalRoles);
    // filter out applicant Guide and itself
    this.filteredRoles = this.destinations.filter((role) => role.shortName !== "AP" && role.id !== this.role.id && !this.isAncestor(role.id))
      .map((item) => {
          return {id: item.id, text: item.name};
    });
    if (this.status.destinations) {
      this.status.destinations.sort((a, b) => a.sortOrder - b.sortOrder).forEach((pair) => {
        const destination = destinations.find((myObj) => myObj.id === pair.destinationId);
        if (destination) {
            this.selectedRoles.push(destination.id);
        }
      });
    }
    this.getRecipientNames();
  }

  public getRecipientNames() {
    this.statusMessages.forEach((statusMessage) => {
      statusMessage.receivers.forEach((receiver) => {
        for (let i = 0; i < this.destinations.length; i++) {
          const destination = this.destinations[i];
          if (destination.id === receiver.receiver) {
            receiver.name = destination.name;
            break;
          } else {
            receiver.name = receiver.receiver;
          }
        }
      });
    });
    this.statusAlerts.forEach((statusAlert) => {
      statusAlert.receivers.forEach((receiver) => {
        for (let i = 0; i < this.destinations.length; i++) {
          const destination = this.destinations[i];
          if (destination.id === receiver.receiver) {
            receiver.name = destination.name;
            break;
          } else {
            receiver.name = receiver.receiver;
          }
        }
      });
    });
  }

  public removed(): void {
    this.saveRoleStatus(this.status.roleStatusType);
  }

  public removeStatusMessage(statusMsg: RoleStatusMessage) {
    if (this.statusMessages) {
      for (let i = 0; i < this.statusMessages.length; i++) {
        if (this.statusMessages[i].id === statusMsg.id) {
          this.statusMessages.splice(i, 1);
          break;
        }
      }
    }
    this.saveRoleStatus(this.status.roleStatusType);
  }

  public removeStatusAlert(statusMsg: RoleStatusMessage) {
    if (this.statusAlerts) {
      for (let i = 0; i < this.statusAlerts.length; i++) {
        if (this.statusAlerts[i].id === statusMsg.id) {
          this.statusAlerts.splice(i, 1);
          break;
        }
      }
    }
    this.saveRoleStatus(this.status.roleStatusType);
  }

  public selected(): void {
    this.saveRoleStatus(this.status.roleStatusType);
  }

  public selectedOne(value: any): void {
    // this.selectedRoles = [value];
    this.saveRoleStatus(this.status.roleStatusType);
  }

  public deleteRoleStatus(isConfirmed, roleStatusId) {
    if (isConfirmed) {
      this.roleStatusControllerService.deleteRoleStatus(roleStatusId).subscribe(
        (data) => {
          this.responseSuccessful("Status deleted!");
          this.roleDetail.reloadRole();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public saveRoleStatus(roleStatusType) {
    this.status.destinations = [];
    this.updateMessages();
    let sortOrder = 0;
    this.selectedRoles.filter((item) => !!item).forEach((it) => {
      const valuePair = this.destinations.find((myObj) => myObj.id === it);
      const destination = {destinationId: valuePair.id, sortOrder};
      sortOrder++;
      this.status.destinations.push(destination);
    });
    // should find a better way of doing this
    if (this.status.roleStatusType === roleStatusType && this.status.roleId === this.roleId) {
      if (roleStatusType === "FileValidatedStatus") {
        this.roleStatusControllerService.saveRoleFileValidatedStatus(this.status.id, this.status).subscribe(
          (data) => {
            this.responseSuccessful("Role status saved!");
            this.closeSection();
            this.getRecipientNames();
          },
          (error) => this.showErrorMessage(error),
        );
      } else if (roleStatusType === "FileDeclineStatus") {
        this.roleStatusControllerService.saveRoleFileDeclineStatus(this.status.id, this.status).subscribe(
          (data) => {
            this.responseSuccessful("Role status saved!");
            this.closeSection();
            this.getRecipientNames();
            // this.statusUpdated.emit({statusUpdated: true});
          },
          (error) => this.showErrorMessage(error),
        );
      } else if (roleStatusType === "FileRejectStatus") {
        this.roleStatusControllerService.saveRoleFileRejectStatus(this.status.id, this.status).subscribe(
          (data) => {
            this.responseSuccessful("Role status saved!");
            this.closeSection();
            this.getRecipientNames();
            // this.statusUpdated.emit({statusUpdated: true});
          },
          (error) => this.showErrorMessage(error),
        );
      } else if (roleStatusType === "UserDefinedStatus") {
        this.roleStatusControllerService.saveRoleUserDefinedStatus(this.status.id, this.status).subscribe(
          (data) => {
            this.responseSuccessful("Role status saved!");
            this.closeSection();
            this.getRecipientNames();
          },
          (error) => this.showErrorMessage(error),
        );
      } else if (roleStatusType === "FilePendingStatus") {
        this.roleStatusControllerService.saveFilePendingStatus(this.status.id, this.status).subscribe(
          (data) => {
            this.responseSuccessful("Role status saved!");
            this.closeSection();
            this.getRecipientNames();
          },
          (error) => this.showErrorMessage(error),
        );
      }
    }
  }

  public updateMessages() {
    this.status.statusMessages = [];
    if (this.statusMessages && this.statusMessages.length > 0) {
      this.statusMessages.forEach((msg) => {
        this.status.statusMessages.push(msg);
      });
    }
    if (this.statusAlerts && this.statusAlerts.length > 0) {
      this.statusAlerts.forEach((msg) => {
        this.status.statusMessages.push(msg);
      });
    }
  }

  public eventStatusMessageWindowSubmitted(event) {
    if (event.save === true && event.roleStatusMessage) {
      if (event.create === true) {
        if (!this.statusMessages) {
          this.statusMessages = [];
        }
        this.statusMessages.push(event.roleStatusMessage);
      }
      this.saveRoleStatus(this.status.roleStatusType);
    }
  }

  public eventStatusMessageAlertWindowSubmitted(event) {
    if (event.save === true && event.roleStatusMessage) {
      if (event.create === true) {
        if (!this.statusAlerts) {
          this.statusAlerts = [];
        }
        this.statusAlerts.push(event.roleStatusMessage);
      }
      this.saveRoleStatus(this.status.roleStatusType);
    }
  }

  public toggleContent() {
    this.hideContent = !this.hideContent;
  }

  public initSectionData(messageType) {
    const messageData = {
      serviceId: this.serviceId,
      statusMessages: this.statusMessages,
      allRoles: this.destinations,
      role: this.role,
      statusType: this.status.roleStatusType,
      messageType,
    };
    this.modalOpenedEvent.emit(messageData);

    this.roleStatusService.serviceId = this.serviceId;
    this.roleStatusService.statusMessages = this.statusMessages;
    this.roleStatusService.allRoles = this.destinations;
    this.roleStatusService.role = this.role;
    this.roleStatusService.statusType = this.status.roleStatusType;
    this.roleStatusService.messageType = messageType;
    this.roleStatusService.initData();
    /*
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "messages";
    */
  }

  public closeSection() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = null;
  }

  public statusMessageSubmit(roleStatusMessage, statusType) {
    let isEdit = false;
    if (!this.statusMessages) {
      this.statusMessages = [];
    }
    this.statusMessages.forEach((statusMessage, index) => {
      if (statusMessage.id === roleStatusMessage.id) {
        this.statusMessages[index] = roleStatusMessage;
        isEdit = true;
      }
    });
    if (!isEdit) {
      this.statusMessages.push(roleStatusMessage);
    }
    this.saveRoleStatus(statusType);
  }

  public statusAlertSubmit(roleStatusMessage, statusType) {
    let isEdit = false;
    if (!this.statusAlerts) {
      this.statusAlerts = [];
    }
    this.statusAlerts.forEach((statusAlert, index) => {
      if (statusAlert.id === roleStatusMessage.id) {
        this.statusAlerts[index] = roleStatusMessage;
        isEdit = true;
      }
    });
    if (!isEdit) {
      this.statusAlerts.push(roleStatusMessage);
    }
    this.saveRoleStatus(statusType);
  }

  public toggleActive(status) {
      status.active = !status.active;
      this.saveRoleStatus(status.roleStatusType);
  }

  public openStatusMessageEdit(roleStatusMessage, messageType) {
    this.roleStatusService.roleStatusMessage = roleStatusMessage;
    this.roleStatusService.messageType = messageType;
    this.roleStatusService.statusType = this.status.roleStatusType;
    this.roleStatusService.initStatusMessageEditData();
  }

  public openMessageEdit(message, messageType) {
    this.roleStatusService.message = message;
    this.roleStatusService.messageType = messageType;
    this.roleStatusService.statusType = this.status.roleStatusType;
    this.roleStatusService.initMessageEditData();
  }
}
